export default class SmsService {
    constructor() {
        this.NUM_CHARS_SINGLE_SMS = 160;
        this.NUM_CHARS_MULTIPART_SMS = 153; // according to GSM 03.38
        this.MAX_SMS = 5;
        this.RULE_SHORTENER_DOMAIN_LENGTH = 10; // i.rule.io or s.rule.io
        this.HASH_LENGTH = 6;
        this.PROTOCOL_LENGTH = 8; // https://

        this.textMessage = {
            sender_name: '',
            content: '',
            contentNotTrimmed: '',
            language: 'sv',
            subject: ''
        };
        this.stopMessage = "";
        this.customDomain = "";

    }

    setTextMessage(message) {
        if (angular.isObject(message.language)) {
            message.language = message.language.data.code;
        }

        angular.extend(this.textMessage, message);
    }

    setStopMessage(message) {
        this.stopMessage = message;
    }

    setCustomDomain(domain) {
        this.customDomain = domain;
    }

    validSMS() {
        var smsRegex = /^[A-ZÅÄÖÆØÑÜÈa-zåäöèéùìòæøñüà0123456789«»“”ʺˮ‟❝❞〝〞"‘’ʻˈʼʽʹ‛'́ˊ`ˋ❛❜̓̔,、÷1⁄41⁄23⁄4⧸̷̸⁄∕/⧹⧵\\̲_⃒⃓∣|⎸⎹⏐⎜⎟⎼⎽―‐•⁃@$ǃ!#%&‚̦❨❪(⟮⦅❩❫)⟯⦆⁎∗⊛✢✣✤✥✱✲✳✺✻✼✽❃❉❊❋⧆*˖+。.ː˸⦂꞉:⁏;<͇꞊=>?AᴀBʙCᴄDᴅEᴇFꜰGɢHʜIɪJᴊKᴋLʟMᴍNɴOᴏPᴘQRʀSꜱTᴛUᴜVᴠWᴡXYʏZᴢˆ̂^᷍❴{❵}\[\]̃˷̴̰∼~​̳—–‹›!!„...0-9#\$£€%&!.,\?\(\)\[\]\s\-_:;\/\+\*=<>|{}"'@~]*$/;

        if (smsRegex.test(this.textMessage.content)) {
            var length = this.getSMSLength();
            // so we check if there is at least something except stop message,
            // also there are alway 1 symbol, don`t know why
            return (length <= this.MAX_SMS * this.NUM_CHARS_MULTIPART_SMS) && (length > this.getStopMessageLength() + 1);
        }

        return false;
    }

    getSMSLength() {
        var content = this.textMessage.content;
        
        return (
            content.replace(/[\t ]+/g, ' ').length
            + this.getStopMessageLength()
            + this.shortenLinkCount()
            + this.getSpecialCharactersCount()
        );
    }

    getStopMessageLength() {
        if (! this.stopMessage)
            return 0;

        try {
            var langEl = $(this.stopMessage).filter('[data-language=' + this.textMessage.language + ']')[0];

            return langEl ? ($(langEl).text().length + 1) : (this.stopMessage.length + 1);
        } catch (e){
            return this.stopMessage.length + 1;
        }
    }

    getNumSms() {
        return this.textMessage.content && this.getSMSLength() > this.NUM_CHARS_SINGLE_SMS ? Math.ceil(this.getSMSLength() / this.NUM_CHARS_MULTIPART_SMS) : 1;
    }

    getRemainChars() {
        return this.MAX_SMS * this.NUM_CHARS_MULTIPART_SMS - this.getSMSLength();
    }

    validSender() {
        return this.textMessage.from_name &&
            this.textMessage.from_name.length > 0 &&
            this.textMessage.from_name.length <= 11;
    }

    getShortenedLinkLength() {
        var shortDomainLength = this.customDomain ? this.customDomain.length : this.RULE_SHORTENER_DOMAIN_LENGTH;

        return this.PROTOCOL_LENGTH + shortDomainLength + this.HASH_LENGTH;
    }

    shortenLinkCount() {
        var linkRegex = /(https?:\/\/[^\s]+)/g;
        var longLinks, longLinksLength = 0, shortLinksLength = 0;

        if(linkRegex.test(this.textMessage.content)){
            longLinks = this.textMessage.content.match(linkRegex);
            longLinks.forEach(function (link) {
                longLinksLength += link.length;
            });
            shortLinksLength = longLinks.length * this.getShortenedLinkLength();
            return (shortLinksLength - longLinksLength);
        } else {
            return 0;
        }
    }

    getSpecialCharactersCount() {
        var specialCharRegex = /[|^€{}~]/g;
        var specialCharsCount = this.textMessage.content.match(specialCharRegex);

        return specialCharsCount ? specialCharsCount.length : 0;
    }

}
